import React from 'react';
import { RouteComponentProps, Switch, Route } from 'react-router-dom';

import { CenteredLayout } from '@lib/common';
import { FeedbackPage } from './pages';

export const FeedbackRoutes: React.FC<RouteComponentProps> = ({ match }) => {
  return (
    <CenteredLayout>
      <Switch>
        <Route exact path={`${match.path}`} component={FeedbackPage} />
      </Switch>
    </CenteredLayout>
  );
};
